<template>
  <div id="about-maindiv" class="page-maindiv">
    <!-- Main -->
    <div id="about" class="area-main">
      <!-- Area titolo -->
      <div class="area-top">
        <div class="area-top-title">
          {{ $t("menu.chisiamo").toUpperCase() }}
        </div>
      </div>
      <div class="area-description" v-html="translatedContentInfoBox"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
  data: function() {
    return {
      contentInfoBox: ""
    };
  },
  created() {
    this.fetchPage()
  },
  computed: {
    translatedContentInfoBox() {
      const content = this.contentInfoBox;
      let result = "";
      for (let i in content) {
        for (let trad in content[i]["traduzioni"]) {
          if (content[i]["traduzioni"][trad]["lingua"].startsWith("it")) {
            result = content[i]["traduzioni"][trad].contenuto;
          }
          if (content[i]["traduzioni"][trad]["lingua"].startsWith(this.$i18n.locale)) {
            result = content[i]["traduzioni"][trad].contenuto;
          }
        }
      }
      return result;
    },
  },
  methods: {
    async fetchPage() {
      const contentDataInfoBox = await this.$client.getItems("pagine", {
        fields: ["*", "traduzioni.*"],
        filter: {
          nome: {
            eq: 'chi_siamo'
          }
        }
      });
      this.contentInfoBox = contentDataInfoBox.data;
    },
  }
}
</script>